import Vue from 'vue';
import Router from 'vue-router';

Vue.use (Router);

export default new Router ({
  // mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {path: '/', redirect: '/IT'},
    {
      path: '/:lang',
      name: 'home',
      component: () => import ('./views/LongForm.vue'),
    },
  ],
});
